import React from 'react';
import ReactMarkdown from 'react-markdown';

const MarkdownTooltip = ({ content, className = "text-[#2E364B]" }) => {
  return (
    <div className={`text-sm font-['Assistant'] ${className}`}>
      <ReactMarkdown 
        components={{
          // Style our markdown elements
          strong: ({node, ...props}) => <span className={`font-semibold ${className}`} {...props} />,
          p: ({node, ...props}) => <p className={`mb-2 ${className}`} {...props} />,
          ul: ({node, ...props}) => <ul className="space-y-2" {...props} />,
          li: ({node, ...props}) => (
            <li className={`flex items-start ${className}`}>
              <span className="mr-2">•</span>
              <span {...props} />
            </li>
          )
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownTooltip;